import { relayAccountKey } from "@maito/client-runtime/relay";
import * as Schema from "effect/Schema";

import { resolveCloudPublicConfig } from "../cloud/publicConfig";

export const STARTUP_ACCOUNT_STORAGE_KEY = "maito:startup-account:v1";
const AccountHint = Schema.Struct({
  accountId: Schema.String,
  organizationId: Schema.String,
  accountKey: Schema.String,
});
const decodeHint = Schema.decodeUnknownSync(Schema.fromJsonString(AccountHint));

export function accountCacheKey(accountId: string, organizationId: string): string | null {
  const config = resolveCloudPublicConfig();
  if (!config.clerkPublishableKey || !config.relayUrl) return null;
  return relayAccountKey({
    publishableKey: config.clerkPublishableKey,
    relayUrl: config.relayUrl,
    accountId,
    organizationId,
  });
}

function readHint() {
  try {
    const raw = localStorage.getItem(STARTUP_ACCOUNT_STORAGE_KEY);
    if (raw === null) return null;
    const hint = decodeHint(raw);
    return hint.accountKey === accountCacheKey(hint.accountId, hint.organizationId) ? hint : null;
  } catch {
    return null;
  }
}

let accountHint = readHint();

/** A remembered identity permits speculative transport, never authenticated UI. */
export function connectionAccountKey(): string | null {
  return accountHint?.accountKey ?? null;
}

export function confirmStartupAccount(
  account: {
    readonly accountId: string;
    readonly organizationId: string;
  } | null,
): void {
  const accountKey =
    account === null ? null : accountCacheKey(account.accountId, account.organizationId);
  accountHint = account !== null && accountKey !== null ? { ...account, accountKey } : null;
  try {
    if (accountHint === null) localStorage.removeItem(STARTUP_ACCOUNT_STORAGE_KEY);
    else localStorage.setItem(STARTUP_ACCOUNT_STORAGE_KEY, JSON.stringify(accountHint));
  } catch {
    // Persistence is optional; the current account still replaces the in-memory hint.
  }
}
